module.exports = __webpack_public_path__ + "static/media/CaptainBattle.3dd5b8d0.png";